<template>
    <div class="p-4">
        <div id="user-details" v-if="user">
            <div class="row">
                <div class="col-md-12">
                    <div class="menu-bar clearfix">
                        <div id="project-info-menu-bar-title" class="pull-left"><h2>General Info</h2></div>

                        <div class="dropdown pull-right">
                            <a class="dropdown-toggle" id="project-info-menu-bar-menu" href="#" data-toggle="dropdown"
                               aria-haspopup="true" aria-expanded="false">
                                <div class="icon icon-dim-32 icon-menu-red"></div>
                            </a>
                            <ul id="project-dropdown-list" class="dropdown-menu">
                                <li><a id="project-info-menu-bar-edit-dropdown" class="dropdown-item" href="javascript:void(0)" v-b-modal.account-modal v-on:click="backupUser">
                                    <div class="icon icon-dim-24 icon-edit-red"></div>
                                    Edit general info</a></li>
                            </ul>

                        </div>
                    </div>


                    <div class="row" id="project-options">
                        <div class="col-sm-10">
                            <div id="project-information-part" class="ml-2">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <p><strong>Name</strong></p>
                                    </div>
                                    <div class="col-sm-10">
                                        <p id="project-name-p">{{ user.name }}</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-2">
                                        <p><strong>MY PLAN</strong></p>
                                    </div>
                                    <div class="col-sm-10">
                                        <p>DEMO</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-2">
                                        <p><strong>User Name</strong></p>
                                    </div>
                                    <div class="col-sm-10">
                                        <p>{{ user.email }}</p>
                                    </div>
                                </div>
                                <div class="row" v-if="hasManagerPermission('profile.change_password')">
                                    <div class="col-sm-2">
                                        <p><strong>Password</strong></p>
                                    </div>
                                    <div class="col-sm-10">
                                        <button class="btn btn-sm btn-danger" v-b-modal.password-modal>Change Password</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-md-12">
                    <div class="menu-bar clearfix">
                        <div id="users-menu-bar-title" class="pull-left"><h2>Billing Info</h2></div>
                    </div>

                    <div class="ml-2">
                        <h6>Here will be all your invoices.</h6>
                    </div>
                </div>
            </div>
        </div>

        <AccountModal v-if="editUser" :user="editUser" v-on:ok="updateUser"></AccountModal>
        <PasswordModal v-if="user" :user="user"></PasswordModal>
    </div>
</template>

<script>
    import AccountModal from "./parts/AccountModal";
    import PasswordModal from "./parts/PasswordModal";
    export default {
        components: {PasswordModal, AccountModal},
        data() {
            return {
                user: null,
                editUser: null
            }
        },
        mounted() {
            this.$store.dispatch('loadLoggedInUser').then(user => {
                this.user = user;
            });
        },
        methods: {
            backupUser(){
                this.editUser = Object.assign({}, this.user);
            },
            updateUser(user){
                this.user = user;
                this.$store.dispatch('syncUser');
            }
        }
    }
</script>

<style scoped>
    .menu-bar {
        width: 100%;
        background-color: transparent;
        border-bottom: 1px solid #dadada;
        margin-bottom: 25px;
    }

    .menu-bar .dropdown-toggle::after {
        display: none;
    }

    .menu-bar h2 {
        font-weight: 400;
        font-size: 1.17em;
        color: #000;
        margin-top: 6px;
        margin-bottom: 6px;
        text-transform: capitalize;
    }

    .pull-left {
        float: left;
    }

    .pull-right {
        float: right;
    }

    .icon-menu-red {
        background-image: url(~@images/menu-red.svg);
    }

    a:hover > .icon-menu-red {
        background-image: url(~@images/menu.svg);
    }

    .icon-edit-red {
        background-image: url(~@images/edit-red.svg);
    }

    a:hover > .icon-edit-red {
        background-image: url(~@images/edit.svg);
    }

    .icon-user-add-red {
        background-image: url(~@images/user-add-red.svg);
    }

    a:hover > .icon-user-add-red {
        background-image: url(~@images/user-add.svg);
    }


    .icon-user-remove-red {
        background-image: url(~@images/user-remove-red.svg);
    }

    a:hover > .icon-user-remove-red {
        background-image: url(~@images/user-remove.svg);
    }

    .icon-user {
        background-image: url(~@images/user.svg);
    }

    .icon-dim-24 {
        height: 24px;
        width: 24px;
    }

    .icon-dim-32 {
        height: 32px;
        width: 32px;
    }

    .icon {
        display: inline-block;
        text-indent: -9999px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    .menu-bar .dropdown * {
        text-decoration: none;
    }

    #project-dashboard-image_2 {
        width: 100%;
        height: 200px;
        background-image: url(~@images/default-project-image.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    ul.dropdown-menu > li > a {
        padding: 3px 20px;
        clear: both;
        font-weight: normal;
        line-height: 1.42857143;
        white-space: nowrap;
        color: #e11f26;
        background-color: #fff;
        display: flex;
        align-items: center;
    }

    ul.dropdown-menu > li > a .icon {
        margin-right: 6px;
    }

    ul.dropdown-menu > li > a:hover {
        color: #000;
        background-color: #fff;
    }

    .table td:last-of-type {
        text-align: left;
    }


    #project-options{
        word-wrap: break-word;
    }
</style>
